import { Button } from '@mui/material'
import styles from './HostServiceCard.module.css'
import { Link } from 'react-router-dom'
import { ImageSlider } from 'shared/ui/strspykit/ImageSlider'
import { UnderObservationDoubleIcon } from 'shared/icons/UnderObservationDoubleIcon'
import { ImageSlider2 } from 'shared/ui/strspykit/ImageSlider2'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'

interface HostServiceCardProps {
    hostService: any
    index: number
    spyId?: number
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
}

export const HostServiceCard = (props: HostServiceCardProps) => {
    const {
        hostService,
        spyId,
        index,
        onStartPropertySpy,
        onStopPropertySpy
    } = props
    const position = hostService.position ? hostService.position : index + 1
    const isXlWidthScreenOrMore = useBreakpointUp('xl')

    if (hostService === undefined) {
        return (
            <></>
        )
    }

    const slides = hostService.strHostservicePictures?.map((strHostservicePicture: any) => {
        return ({
            src: strHostservicePicture.url,
            title: strHostservicePicture.description,
            id: strHostservicePicture.id
        })
    })

    const stateSpyText = hostService.propSpy === true ? `Stop spy` : `Spy it`
    const handleStateSpy = (event: any) => {
        if (hostService.propSpy === true) {
            onStopPropertySpy?.(hostService)
            return
        }

        onStartPropertySpy?.(hostService)
    }

    let costText = `X`
    if (hostService?.priceTotal !== undefined && hostService?.priceTotal?.list?.length > 0){
        costText = `$${hostService?.priceTotal.list[0].value}`
    }

    const renderUnderObservation = (): JSX.Element => {
        if (hostService.propSpy === true) {
            return (
                <div className={styles.HostServiceCard__UnderObservation}>
                    <UnderObservationDoubleIcon
                        className={styles.HostServiceCard__UnderObservationIcon}
                    />
                    <div className={styles.HostServiceCard__UnderObservationBg}>

                    </div>
                </div>
            )
        }

        return (<></>)
    }

    return (
        <div className={styles.HostServiceCard__Root}>
            <div className={styles.HostServiceCard__ImageSliderContainer}>
                <ImageSlider2
                    images={slides}
                />
                {renderUnderObservation() }
                <div className={styles.HostServiceCard__Position}>
                    <div className={styles.HostServiceCard__PositionLabel}>
                        Position:
                    </div>
                    <div className={styles.HostServiceCard__PositionValue}>
                        {position}
                    </div>
                </div>
                <div className={styles.HostServiceCard__Cost}>
                    <div className={styles.HostServiceCard__CostValue}>
                        {costText}
                    </div>
                </div>
            </div>
            <div className={styles.HostServiceCard__NameContainer}>
                <div className={styles.HostServiceCard__Name}>
                    {hostService.name}
                </div>
            </div>
            <div className={styles.HostServiceCard__MainToolbar}>
                <Link 
                    className={styles.HostServiceCard__DetailsLink} 
                    to={`/hostservice/${hostService.id}?monitoridforprices=${spyId}`}
                >
                    <Button
                        className={styles.HostServiceCard__Button}
                        color="success"
                        variant="contained"
                        sx={{
                            fontSize: '20px',
                            textTransform: 'none'
                        }}
                    >
                        Details
                    </Button >
                </Link>
                <Button
                    className={styles.HostServiceCard__Button}
                    color="success"
                    variant="outlined"
                    onClick={handleStateSpy}
                    sx={{
                        textTransform: 'none',
                        borderWidth: '2px!important',
                        background: `#FFFF`
                    }}
                >
                    {stateSpyText}
                </Button >
            </div>
      
        </div>
    )
}